import { AdmDependencyAndLocation } from './adm-dependency-and-location';
import { Footnote } from '../../../shared/components/footnote/entities/footnote';

export class QuantityByAdmDependencyAndLocation {
    admDependenciesAndLocations: Array<AdmDependencyAndLocation> = new Array<AdmDependencyAndLocation>();
    source: Footnote;
    note: Footnote;
}
